import { useEffect } from 'react';
import Lenis from 'lenis';
import { Toaster } from 'sonner';
import '@/App.css';
import { gsap, ScrollTrigger } from '@/lib/gsapSetup';
import Cursor from '@/components/Cursor';
import Navbar from '@/components/Navbar';
import Marquee from '@/components/Marquee';
import Hero from '@/sections/Hero';
import TheShift from '@/sections/TheShift';
import Intro from '@/sections/Intro';
import EnergyFlow from '@/sections/EnergyFlow';
import Ecosystem from '@/sections/Ecosystem';
import BrandExploration from '@/sections/BrandExploration';
import Capabilities from '@/sections/Capabilities';
import Markets from '@/sections/Markets';
import GlobalNetwork from '@/sections/GlobalNetwork';
import Growth from '@/sections/Growth';
import Future from '@/sections/Future';
import Contact from '@/sections/Contact';

function App() {
  useEffect(() => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    ScrollTrigger.config({ ignoreMobileResize: true });
    let lenis;
    let rafFn;
    if (!reduced) {
      lenis = new Lenis({ lerp: 0.11, wheelMultiplier: 1, touchMultiplier: 1.4 });
      window.lenis = lenis;
      lenis.on('scroll', ScrollTrigger.update);
      rafFn = (time) => lenis.raf(time * 1000);
      gsap.ticker.add(rafFn);
      gsap.ticker.lagSmoothing(0);
    }
    const refresh = () => ScrollTrigger.refresh();
    window.addEventListener('load', refresh);
    if (document.fonts?.ready) document.fonts.ready.then(refresh);
    const t = setTimeout(refresh, 1200);
    return () => {
      window.removeEventListener('load', refresh);
      clearTimeout(t);
      if (lenis) {
        gsap.ticker.remove(rafFn);
        lenis.destroy();
        window.lenis = null;
      }
    };
  }, []);

  return (
    <div data-testid="amaya-energy-app" className="bg-[#000000] text-white">
      <Cursor />
      <Navbar />
      <main>
        <Hero />
        <TheShift />
        <Intro />
        <EnergyFlow />
        <Ecosystem />
        <Marquee />
        <BrandExploration />
        <Capabilities />
        <Markets />
        <GlobalNetwork />
        <Growth />
        <Future />
        <Contact />
      </main>
      <div className="noise-overlay" aria-hidden="true" />
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
